// extracted by mini-css-extract-plugin
export var bgClassName = "Hero5050-module--bgClassName--3184f";
export var herSlideContent = "Hero5050-module--herSlideContent--a3f51";
export var hero5050Container = "Hero5050-module--hero5050Container--f4258";
export var hero5050ContentSection = "Hero5050-module--hero5050ContentSection--caaf8";
export var hero5050ContentStyling = "Hero5050-module--hero5050ContentStyling--4ad1e";
export var hero5050promoContainer = "Hero5050-module--hero5050promoContainer--301e3";
export var heroContentHeading = "Hero5050-module--heroContentHeading--3d303";
export var heroHeadingStyling = "Hero5050-module--heroHeadingStyling--59932";
export var heroUspContainer = "Hero5050-module--heroUspContainer--86b04";
export var heroUspContent = "Hero5050-module--heroUspContent--44f2d";
export var heroUspIndicator = "Hero5050-module--heroUspIndicator--964a4";